import { render, staticRenderFns } from "./FormatTab.vue?vue&type=template&id=5f785180&"
import script from "./FormatTab.vue?vue&type=script&lang=ts&"
export * from "./FormatTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports